<div class="component-chart-view">
  <h5 *ngIf="chartData?.chart_title as title">{{ title }}</h5>
  <canvas id="chart-element" #elementChartCanvas></canvas>
</div>
